import React, { useEffect, useState, useRef } from "react";
import { bindElements } from "./../../../utils/amplitude-util";
import { Box, Slider, Stack } from "@mui/material";
import { VolumeUp, VolumeDown } from "@mui/icons-material";
export default function VolumeSlider() {
  let [volume, setVolume] = useState(50);
  let volumeSLiderRef = useRef(null);
  useEffect(() => {
    console.log("AudioPlayer rendered");
    bindElements();
  }, []);
  function handleVolumeChange(e, val) {
    setVolume(val);
    //for chrome and fire fox
    let event1 = new Event("input");
    //for ie
    let event2 = new Event("change");
    volumeSLiderRef.current.value = val;
    volumeSLiderRef.current.dispatchEvent(event1);
    volumeSLiderRef.current.dispatchEvent(event2);
  }
  return (
    <Box>
      <Stack
        spacing={2}
        style={{ width: 200, display: "box" }}
        direction="row"
        sx={{ mb: 1 }}
        alignItems="center">
        <VolumeDown />
        <Slider
          aria-label="Volume"
          ref={volume.current}
          value={volume}
          size="small"
          onChange={handleVolumeChange}
        />
        <VolumeUp />
      </Stack>
      <input
        ref={volumeSLiderRef}
        value={volume}
        style={{ display: "none" }}
        type="range"
        class="amplitude-volume-slider"
      />
    </Box>
  );
}
